








import Vue from 'vue';
import Component from 'vue-class-component';
import {PropSync, Watch} from "vue-property-decorator";

@Component
export default class Accordion extends Vue {

	@PropSync('open', { default: false }) _open!: boolean;

	fullHeight: number = 0;

	get style(): Record<string, string> {
		const calcHeight = this._open ? this.fullHeight : 0;
		return {
			height: `${calcHeight}px`,
		};
	}

	@Watch('open')
	onOpenChanged(newVal: boolean, oldVal: boolean): void {
		if (newVal) {
			requestAnimationFrame(() => {
				this.recalculateHeight();
				requestAnimationFrame(() => {
					this.recalculateHeight();
				});
			});
		}
	}

	created(): void {
		window.addEventListener('resize', this.recalculateHeightOnResize);
	}

	mounted(): void {
		this.recalculateHeight();
	}

	unmounted(): void {
		window.removeEventListener('resize', this.recalculateHeightOnResize);
	}

	recalculateHeightOnResize(): void {
		this.recalculateHeight();
	}

	recalculateHeight(): void {
		this.fullHeight = (this.$refs.accordionInner as HTMLElement).clientHeight;
	}
}
